/**
 * @license
 * SPDX-License-Identifier: Apache-2.0
 */

import { isPagesPreview } from './env';

/**
 * Initializes analytics libraries. Skips initialization on Cloudflare Pages preview domains
 * to prevent inflating production traffic statistics.
 */
export const initializeAnalytics = (): void => {
  if (typeof window === 'undefined') return;

  if (isPagesPreview()) {
    console.log('Analytics: Skipping initialization on Pages preview deployment:', window.location.hostname);
    return;
  }

  console.log('Analytics: Initialized successfully on production or local environment');
};
